import axios from 'axios'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { ShipmentItemResponse } from '@/modules/shipments-module/services/shipments.dto'

class ShipmentsItemFinderService {
    // Gets a list of pending elements to be received in a laboratory
    async findPendingToBeReceived(
        destinationLaboratoryId: number,
        filterModel?: CommonFilterModel,
        params?: CommonParams
    ): Promise<IResponseAgGrid<ShipmentItemResponse>> {
        const response = await axios.put<IResponseAgGrid<ShipmentItemResponse>>(
            `/shipments/laboratories/${destinationLaboratoryId}/shipmentItemsPendingToBeReceived`,
            { ...filterModel },
            { params })
        return response.data
    }

    // Returns the summary of pending elements to be received in a laboratory
    async getPendingToBeReceivedSummary(
        destinationLaboratoryId: number
    ): Promise<number> {
        const response = await axios.get<number>(
            `/shipments/laboratories/${destinationLaboratoryId}/shipmentItemsPendingToBeReceived/summary`)
        return response.data
    }

    // Gets a list of received elements in a laboratory
    async findReceived(
        destinationLaboratoryId: number,
        filterModel?: CommonFilterModel,
        params?: CommonParams
    ): Promise<IResponseAgGrid<ShipmentItemResponse>> {
        const response = await axios.put<IResponseAgGrid<ShipmentItemResponse>>(
            `/shipments/laboratories/${destinationLaboratoryId}/shipmentItemsReceived`,
            { ...filterModel },
            { params })
        return response.data
    }

    // Gets a list of sent elements in a laboratory
    async findSent(
        originLaboratoryId: number,
        filterModel?: CommonFilterModel,
        params?: CommonParams
    ): Promise<IResponseAgGrid<ShipmentItemResponse>> {
        const response = await axios.put<IResponseAgGrid<ShipmentItemResponse>>(
            `/shipments/laboratories/${originLaboratoryId}/shipmentItemsSent`,
            { ...filterModel },
            { params })
        return response.data
    }

    // Gets a list of shipment items by shipment label
    async findByLabel(
        laboratoryId: number,
        shipmentLabel: string,
        filterModel?: CommonFilterModel,
        params?: CommonParams
    ): Promise<IResponseAgGrid<ShipmentItemResponse>> {
        const response = await axios.put<IResponseAgGrid<ShipmentItemResponse>>(
            `/shipments/laboratories/${laboratoryId}/shipmentItems/shipmentLabel/${shipmentLabel}`,
            { ...filterModel },
            { params })
        return response.data
    }
}

export const shipmentsItemFinderService = new ShipmentsItemFinderService()
